import { RegistrationTypes } from './AnonymousHeader/RegistrationModal/RegistrationEnums';

const getModalTitle = (type: string, isMustHaveAccountModal: boolean) => {
	switch (type) {
		case RegistrationTypes.SignUp:
			return isMustHaveAccountModal
				? 'you_must_have_an_edelweiss_account'
				: 'sign_up_for_an_edelweiss_account';
		case RegistrationTypes.LogIn:
			return 'log_in_with_your_edelweiss_account';
		default:
			return type;
	}
};

export const getRegistrationModalTitle = (type: string) => {
	return getModalTitle(type, false);
};

export const getAccountRequiredModalTitle = (type: string) => {
	return getModalTitle(type, true);
};
